<template>
  <div>
    <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="50"
                  :options.sync="params.options" :server-items-length="params.total"
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [20, 50, 100]}">
      <template v-slot:top>
        <v-toolbar flat>
          <statistics ref="stat" :params="params" :selected-timer="selectedTimer"/>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer/>
            <v-text-field class="search" append-icon="mdi-magnify" label="搜索"
                          single-line hide-details clearable v-model="params.filters.search" @click:append="getData"
                          @click:clear="clear" @keydown.enter="getData"></v-text-field>
            <v-btn icon @click="openFilterDialog">
              <v-icon>mdi-filter-menu</v-icon>
            </v-btn>
            <v-btn icon @click="getData">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <template v-slot:extension v-if="$vuetify.breakpoint.xsOnly">
            <v-spacer/>
            <v-text-field class="search" append-icon="mdi-magnify" label="搜索"
                          single-line hide-details clearable v-model="params.filters.search" @click:append="getData"
                          @click:clear="clear" @keydown.enter="getData"></v-text-field>
            <v-btn icon @click="openFilterDialog">
              <v-icon>mdi-filter-menu</v-icon>
            </v-btn>
            <v-btn icon @click="getData">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.imageUrl="{ item }">
        <img alt="商品主图" :src="item.imageUrl" height="80" width="80"/>
      </template>
      <template v-slot:item.asin="{ item }">
        <v-btn link text :href="item.marketplaceUrl + '/dp/' + item.asin" target="_blank" color="primary">{{ item.asin }}</v-btn>
        <br/>
        <label>{{ item.sku }}</label>
      </template>
      <template v-slot:item.sales="{ item }">
        <label>订单: {{ item.orders }}</label><br/>
        <label>销量: {{ item.sales }}</label><br/>
        <!--<label>总价: {{ item.total | numberSplit }}</label><br/>
        <label>单价: {{ item.total | div(item.sales) }}</label>-->
      </template>
      <template v-slot:item.lastDay="{ item }">
        <v-container v-if="item.lastDay">
          <label>{{ item.lastDayCurrently ? item.lastDayCurrently.orders : 0 }} / {{ item.lastDay.orders }}</label><br/>
          <label>{{ item.lastDayCurrently ? item.lastDayCurrently.sales : 0 }} / {{ item.lastDay.sales }}</label><br/>
          <!--<label>{{ item.lastDay.total | numberSplit }}</label><br/>
          <label>{{ item.lastDay.total | div(item.lastDay.sales) }}</label>-->
        </v-container>
      </template>
      <template v-slot:item.lastWeek="{ item }">
        <v-container v-if="item.lastWeek">
          <label>{{ item.lastWeekCurrently ? item.lastWeekCurrently.orders : 0 }} / {{ item.lastWeek.orders }}</label><br/>
          <label>{{ item.lastWeekCurrently ? item.lastWeekCurrently.sales : 0 }} / {{ item.lastWeek.sales }}</label><br/>
          <!--<label>{{ item.lastWeek.total | numberSplit }}</label><br/>
          <label>{{ item.lastWeek.total | div(item.lastWeek.sales) }}</label>-->
        </v-container>
      </template>
      <template v-slot:item.salesRanks="{ item }">
        <v-container v-if="item.salesRanks">
          <label v-for="(salesRank, i) of item.salesRanks" :key="i">
            {{ salesRank.productCategory ? salesRank.productCategory : salesRank.productCategoryId }}: {{
              salesRank.curRank
            }}
            <br/>
          </label>
        </v-container>
        <v-container v-else>
          <label>加载中...</label>
        </v-container>
      </template>
    </v-data-table>
    <today-filter :visible.sync="filterDialog" :params="params" @reload="getData"/>
  </div>

</template>

<script>
import Statistics from "@/page/Today/Statistics";
import TodayFilter from "@/page/Today/TodayFilter";
export default {
  name: "Today",
  components: {TodayFilter, Statistics},
  props: {
    selectedTimer: {
      type: String
    }
  },
  data() {
    return {
      loading: true,
      headers: [
        {text: "店铺", align: "center", sortable: false, value: "store"},
        {text: "图片", align: "center", sortable: false, value: "imageUrl"},
        {text: "ASIN", align: "center", sortable: false, value: "asin"},
        {text: "今日销售", align: "left", value: "sales"},
        {text: "昨日销售", align: "left", sortable: false, value: "lastDay"},
        {text: "上周同日", align: "left", sortable: false, value: "lastWeek"},
        {text: "排名", align: "center", sortable: false, value: "salesRanks"},
      ],
      items: [],
      params: {
        options: {
          sortBy: ["sales"],
          sortDesc: [true]
        },
        filters: {
          search: null,
          marketplaces: [],
          stores: [],
          asins: [],
          skus: [],
          selectedTimer: this.selectedTimer
        },
        total: null,
      },
      filterDialog: false,
    }
  },
  methods: {
    getData() {
      this.items = [];
      this.loading = true;
      console.debug("拉取Today的数据: ", this.params);

      this.$axios.post("/products/today", this.params).then(
          response => {
            console.log(response.data);
            if (response.data && response.data.list && response.data.list.length > 0) {
              this.items = response.data.list;
              this.params.total = response.data.total;

              for (let item of this.items) {
                this.$axios.get(this.$format("/products/{}/salesRank", item.productId)).then(
                    response => {
                      this.$set(item, "salesRanks", response.data);
                    }
                );
              }
            }
            this.loading = false;
          }
      );

      this.$bus.$emit("updateStat");
    },
    reset() {
      this.params.filters.search = null;
      this.params.filters.marketplaces = [];
      this.params.filters.stores = [];
      this.params.filters.asins = [];
      this.params.filters.skus = [];
      this.filterDialog = false;
      this.getData();
    },
    clear() {
      setTimeout(function () {
        this.getData();
      }.bind(this), 300);
    },
    openFilterDialog() {
      this.filterDialog = true;
    },
    initCheckedMarketplace() {
      if (this.selectedTimer !== "CN") {
        this.params.filters.marketplaces = [this.selectedTimer];
        console.debug("默认选中的平台为: ", this.params.filters.marketplaces)
      } else {
        this.params.filters.marketplaces = [];
      }

      this.params.filters.search = null;
      this.params.filters.stores = [];
      this.params.filters.asins = [];
      this.params.filters.skus = [];
    },
  },
  beforeMount() {
    this.initCheckedMarketplace();
    /*let paramsStr = localStorage.getItem("params");

    if (paramsStr) {
      this.params = JSON.parse(paramsStr);
    }*/
    // this.initCheckedMarketplace();
  },
  watch: {
    selectedTimer: {
      handler() {
        console.debug("修改了当前国家: ", this.selectedTimer);
        this.params.filters.selectedTimer = this.selectedTimer;
        this.initCheckedMarketplace();
        this.getData();
        this.$bus.$emit("clearStat");
      }
    },
    "params.options": {
      deep: true,
      handler() {
        console.debug("Today页面的options发生了修改: ", this.params.options);
        this.getData();
      }
    },
  }
}
</script>

<style scoped>
.v-toolbar__content {
  padding-left: 0 !important;
}
</style>